import { useState } from "react";
import type { FC } from "react";
import Proptypes from "prop-types";
import { Menu, MenuItem } from "@material-ui/core";
import { confidenceIndice } from '../../static-data';
import { useTranslation } from "react-i18next";
import { ConfidenceSegments } from './confidence-segments';

interface ConfidenceTabItemProps {
  label: string
  option: string;
  value: number;
  isActive: boolean;
  onChangeField: (screen: string, value: number) => void;
}

export const ConfidenceTabItem: FC<ConfidenceTabItemProps> = (props) => {
  const { label, option, value, isActive, onChangeField } = props;

  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleConfidenceChange = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = (screen: string, value: number) => {
    onChangeField(screen, value);
    setAnchorEl(null);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <div style={{ display: "inline-block", fontWeight: isActive ? '600': '' }}>{label}</div>
      { value !== 0 && (
        <>
        <span
        onClick={handleConfidenceChange}
        style={{ display: "inline-block", marginLeft: "15px", cursor: "pointer" }}
      >
        <ConfidenceSegments level={value} />
      </span>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {Object.keys(confidenceIndice).map((c) => (
          <MenuItem key={c} onClick={() => handleClose(option, parseInt(c, 10))} sx={{ gap: 1 }}>
            <ConfidenceSegments level={parseInt(c, 10)} />
            <div>{t(confidenceIndice[c]['label'])}</div>
          </MenuItem>
        ))}
        {/* <MenuItem onClick={() => handleClose(option, 1)}>
          <div
            style={{
              height: "20px",
              width: "20px",
              backgroundColor: "red",
              display: "inline-block",
              borderRadius: "50px",
            }}
          />
        </MenuItem>
        <MenuItem onClick={() => handleClose(option, 2)}>
          <div
            style={{
              height: "20px",
              width: "20px",
              backgroundColor: "yellow",
              display: "inline-block",
              borderRadius: "50px",
            }}
          />
        </MenuItem>
        <MenuItem onClick={() => handleClose(option, 3)}>
          <div
            style={{
              height: "20px",
              width: "20px",
              backgroundColor: "green",
              display: "inline-block",
              borderRadius: "50px",
            }}
          />
        </MenuItem> */}
      </Menu>
      </>
      )}
    </div>
  );
};

ConfidenceTabItem.propTypes = {
  label: Proptypes.string.isRequired,
  option: Proptypes.string.isRequired,
  value: Proptypes.number,
  onChangeField: Proptypes.func,
  isActive: Proptypes.bool,
};
